module.exports = {
  domain: 'E',
  title: 'Extraversion',
  shortDescription: 'Η εξωστρέφεια χαρακτηρίζεται από έντονη δέσμευση στον εξωτερικό κόσμο.',
  description: `Οι εξορύξεις απολαμβάνουν να είναι με τους ανθρώπους, είναι γεμάτες ενέργεια, και
συχνά αισθάνονται θετικά συναισθήματα. Τείνουν να είναι ενθουσιασμένοι,
προσανατολισμένοι στην δράση, άτομα που είναι πιθανό να πουν "Ναι!" ή "Ας
πηγαίνετε! "σε ευκαιρίες για ενθουσιασμό.Σε ομάδες, τους αρέσει να μιλάνε,
βεβαιώνουν τον εαυτό τους και εφιστούν την προσοχή στον εαυτό τους.
<br /><br />
Οι εσωστρεφείς δεν έχουν τα επίπεδα ευφορίας, ενέργειας και δραστηριότητας
εξωστρεφείς. Έχουν την τάση να είναι ήσυχα, χαμηλά κλειδιά, σκόπιμα, και
απεμπλακεί από τον κοινωνικό κόσμο. Η έλλειψη κοινωνικής συμμετοχής
δεν πρέπει να ερμηνεύεται ως συστολή ή κατάθλιψη. ο
το εσωστρεφές χρειάζεται απλώς λιγότερη διέγερση από ένα εξωστρεφές και προτιμά
να είμαι μόνος. <br /><br />Η ανεξαρτησία και το απόθεμα του εσωστρεφούς είναι
μερικές φορές είναι λανθασμένες ως εχθρότητα ή αλαζονεία. Στην πραγματικότητα, ένα
εσωστρεφής που βαθμολογεί ψηλά την διάσταση της ευτυχίας δεν θα το κάνει
αναζητήστε τους άλλους εκτός, αλλά θα είναι αρκετά ευχάριστο όταν πλησιάσετε.`,
  results: [{
    score: 'low',
    // do not translate this line
    text: `Η βαθμολογία σας στην Εξωστρέφεια είναι χαμηλή, υποδεικνύοντας ότι είστε
εσωστρεφής, δεσμευμένος και ήσυχος. Απολαμβάνετε μοναξιά και μοναξιά
δραστηριότητες. Η κοινωνικοποίηση σας τείνει να περιορίζεται σε λίγους στενούς φίλους.`
  }, {
    score: 'neutral',
    // do not translate this line
    text: `Η βαθμολογία σας στο Extraversion είναι μέση, υποδεικνύοντας ότι είστε
ούτε ένας υποκινούμενος μοναχός ούτε ένας ζωντανός κουβεντιέρας. Απολαμβάνετε χρόνο με
άλλοι αλλά και μόνο ο χρόνος.`
  }, {
    score: 'high',
    // do not translate this line
    text: `Η βαθμολογία σας στο Extraversion είναι υψηλή, υποδεικνύοντας ότι είστε
κοινωνικό, εξερχόμενο, ενεργητικό και ζωντανό. Προτιμάτε να είστε γύρω σας
ανθρώπους πολλές φορές.`
  }],
  facets: [{
    facet: 1,
    title: 'Friendliness',
    text: `Φιλικοί άνθρωποι πραγματικά όπως άλλοι άνθρωποι
και επιδεικνύουν ανοιχτά θετικά συναισθήματα προς τους άλλους. Κάνουν
φίλους γρήγορα και είναι εύκολο για αυτούς να σχηματίσουν στενή, οικεία
σχέσεις. Οι χαμηλοί σκόρερ για την φιλικότητα δεν είναι απαραιτήτως κρύες
και εχθρικά, αλλά δεν φτάνουν σε άλλους και είναι αντιληπτά
ως απομακρυσμένη και αποκλειστική.`
  }, {
    facet: 2,
    title: 'Gregariousness',
    text: `Γκρίζα άτομα βρίσκουν την εταιρεία του
άλλοι ευχάριστα τόνωση και ανταμοιβή. Απολαμβάνουν το
τον ενθουσιασμό των πλήθους. Οι χαμηλοί σκόρερ τείνουν να αισθάνονται συγκλονισμένοι, και
ως εκ τούτου, να αποφύγει ενεργά, μεγάλα πλήθη. Δεν είναι απαραιτήτως
δεν θέλουν να είναι με τους ανθρώπους μερικές φορές, αλλά η ανάγκη τους για την προστασία της ιδιωτικής ζωής και
ο χρόνος για τον εαυτό τους είναι πολύ μεγαλύτερος από ό, τι για τα άτομα που βαθμολογούν
υψηλή σε αυτήν την κλίμακα.`
  }, {
    facet: 3,
    title: 'Assertiveness',
    text: `Υψηλούς σκόρερ Η βεβαιότητα θέλει να μιλήσει
να αναλάβει την ευθύνη και να κατευθύνει τις δραστηριότητες των άλλων. Εχουν την τάση
να είναι ηγέτες σε ομάδες. Οι χαμηλοί σκόρερ τείνουν να μην μιλούν πολύ και να αφήνουν
άλλοι ελέγχουν τις δραστηριότητες των ομάδων.`
  }, {
    facet: 4,
    title: 'Activity Level',
    text: `Τα ενεργά άτομα οδηγούν γρήγορα, απασχολημένα
ζωή. Κινούνται γρήγορα, δυναμικά και σθεναρά, και
εμπλέκονται σε πολλές δραστηριότητες. Οι άνθρωποι που σκοράρουν σε αυτό
η κλίμακα ακολουθεί έναν πιο αργό και πιο χαλαρό, χαλαρό ρυθμό.`
  }, {
    facet: 5,
    title: 'Excitement-Seeking',
    text: `Οι υψηλοί σκόρερ σε αυτή την κλίμακα είναι εύκολα
βαρεθεί χωρίς υψηλά επίπεδα διέγερσης. Λατρεύουν τα λαμπρά φώτα
και θορυβοποίηση. Είναι πιθανό να αναλάβουν κινδύνους και να αναζητήσουν
συγκινήσεις. Οι χαμηλοί σκόρερ είναι συγκλονισμένοι από το θόρυβο και την αναταραχή και είναι
δυσμενείς στην αναζήτηση συναρπαστικών.`
  }, {
    facet: 6,
    title: 'Cheerfulness',
    text: `Αυτή η κλίμακα μετρά θετική διάθεση και
συναισθήματα, όχι αρνητικά συναισθήματα (τα οποία αποτελούν μέρος του
Τομέας νευροεπιστημών). Άτομα που βαθμολογούνται ψηλά σε αυτή την κλίμακα τυπικά
δοκιμάστε μια σειρά από θετικά συναισθήματα, συμπεριλαμβανομένης της ευτυχίας,
τον ενθουσιασμό, την αισιοδοξία και τη χαρά. Οι χαμηλοί σκόρερ δεν είναι τόσο επιρρεπείς σε τέτοια
ενεργειακά, υψηλά πνεύματα.`
  }]
};